import React, { Component, PureComponent, Fragment } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import withStyles from '@material-ui/core/styles/withStyles'
import GoogleMap from 'google-map-react'
import config from '../../../data/SiteConfig'
import { OutboundLink } from 'gatsby-plugin-google-analytics'
// import markerSVG from '../../assets/img/map-marker.svg'
import Button from '../CustomButtons/Button'
import { primaryColor } from '../../assets/jss/material-kit-pro-react'
import BNIcon from '../../assets/img/BNIcon.svg'
import Dialog from '@material-ui/core/Dialog'
import DialogTitle from '@material-ui/core/DialogTitle'
import DialogContent from '@material-ui/core/DialogContent'
import Slide from '@material-ui/core/Slide'
import CardHeader from '../../components/Card/CardHeader.jsx'
import CardBody from '../../components/Card/CardBody.jsx'
// @material-ui/icons
import Close from '@material-ui/icons/Close'
import javascriptStyles from '../../assets/jss/material-kit-pro-react/views/componentsSections/javascriptStyles.jsx'

function Transition(props) {
  return <Slide direction="down" {...props} />
}

class MapMarker extends PureComponent {
  constructor(props) {
    super(props)

    this.state = {
      detailsShown: false,
      appointmentModal: false,
      appointmentSrc: '',
    }
    this.setWrapperRef = this.setWrapperRef.bind(this)
    this.handleClickOutside = this.handleClickOutside.bind(this)
  }

  static propTypes = {
    children: PropTypes.element.isRequired,
    classes: PropTypes.object,
  }

  setWrapperRef(node) {
    this.wrapperRef = node
  }

  handleClickOutside(event) {
    if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
      this.setState({ detailsShown: false, appointmentModal: false })
    }
  }

  componentDidMount() {
    document.addEventListener('mousedown', this.handleClickOutside)
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside)
  }
  render() {
    const { title, address, appointmentBooking, classes } = this.props
    const { detailsShown } = this.state
    return (
      <StyledMarker size={30}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          version="1.1"
          id="Capa_1"
          x="0px"
          y="0px"
          viewBox="0 0 512 512"
          style={{ 'enable-background': 'new 0 0 512 512' }}
          className={detailsShown ? 'marker active' : 'marker'}
          onClick={e => {
            this.setState(prevState => ({
              detailsShown: !prevState.detailsShown,
            }))
            e.preventDefault()
          }}
        >
          <g>
            <path
              d="M256,0C167.641,0,96,71.625,96,160c0,24.75,5.625,48.219,15.672,69.125C112.234,230.313,256,512,256,512l142.594-279.375   C409.719,210.844,416,186.156,416,160C416,71.625,344.375,0,256,0z M256,256c-53.016,0-96-43-96-96s42.984-96,96-96   c53,0,96,43,96,96S309,256,256,256z"
              stroke-width="25"
              stroke={detailsShown ? '#212457' : '#ffffff'}
              fill={detailsShown ? '#7cf8fa' : '#212457'}
            />
          </g>
        </svg>
        {detailsShown && (
          <div ref={this.setWrapperRef}>
            <img className="icon" src={BNIcon} alt="BitNational Logo" />
            <CloseButton
              size="sm"
              simple
              color="primary"
              onClick={e => {
                this.setState({ detailsShown: false })
                e.preventDefault()
              }}
            >
              ｘ
            </CloseButton>
            <h6>{title}</h6>
            <p>{address}</p>
            <Button
              target="_blank"
              href={`https://www.google.com/maps/dir/?api=1&destination=${address.replace(
                /,? /g,
                '+'
              )}`}
              size="sm"
              color="info"
            >
              Get Directions
            </Button>
            {appointmentBooking && (
              <Fragment>
                <Button
                  onClick={() =>
                    this.setState({
                      appointmentModal: true,
                      appointmentSrc: appointmentBooking,
                    })
                  }
                  size="sm"
                  simple
                  color="primary"
                >
                  Book Appointment
                </Button>
                <Dialog
                  classes={{
                    root: classes.modalRoot,
                    paper: classes.modal + ' ' + classes.modalLogin,
                  }}
                  open={this.state.appointmentModal}
                  TransitionComponent={Transition}
                  onClose={() => this.setState({ appointmentModal: false })}
                >
                  <DialogTitle className={classes.modalHeader}>
                    <CardHeader
                      className={`${classes.textCenter} ${
                        classes.cardLoginHeader
                      }`}
                      plain
                      color="primary"
                    >
                      Book an Appointment
                      <Button
                        onClick={() =>
                          this.setState({ appointmentModal: false })
                        }
                        style={{ position: 'absolute', top: 0, right: 5 }}
                        size="sm"
                        justIcon
                        color="info"
                        simple
                      >
                        <Close />
                      </Button>
                    </CardHeader>
                  </DialogTitle>
                  <DialogContent className={classes.modalBody}>
                    <CardBody className={classes.cardLoginBody} />
                  </DialogContent>
                  <iframe
                    src={this.state.appointmentSrc}
                    width="100%"
                    height="100%"
                    scrolling="yes"
                    style={{ border: 0, borderRadius: '0 0 6px 6px' }}
                  />
                </Dialog>
              </Fragment>
            )}
          </div>
        )}
      </StyledMarker>
    )
  }
}

const StyledMapMarker = withStyles(javascriptStyles)(MapMarker)

const GoogleMaps = ({ defaultCenter, defaultZoom, markerData }) => (
  <MapContainer>
    <GoogleMap
      bootstrapURLKeys={{ key: config.googleMapsAPIKey }}
      defaultCenter={defaultCenter}
      defaultZoom={defaultZoom}
    >
      {markerData.map(marker => (
        <StyledMapMarker
          key={marker.address + marker.title}
          title={marker.title}
          appointmentBooking={marker.appointmentBooking}
          address={marker.address}
          lat={marker.location.lat}
          lng={marker.location.lng}
        />
      ))}
    </GoogleMap>
  </MapContainer>
)

GoogleMaps.defaultProps = {
  defaultCenter: { lat: 50.5452752, lng: -118.905826 },
  defaultZoom: 7.25,
}

const CloseButton = styled(Button)`
  &&& {
    position: absolute;
    top: 0px;
    right: 5px;
  }
`

const StyledMarker = styled.div`
  height: ${p => p.size}px;
  width: ${p => p.size}px;
  position: absolute;
  left: -${p => p.size / 2}px;
  top: -${p => p.size / 2}px;

  img.icon {
    height: ${p => p.size}px;
    width: ${p => p.size}px;
  }

  svg.marker {
    height: ${p => p.size}px;
    width: ${p => p.size}px;
    cursor: pointer;
    path {
      transition: 150ms;
    }

    &:hover {
      path {
        stroke: hsl(181, 92.6%, 50%);
      }
    }
  }

  div {
    text-align: center;
    position: relative;
    left: 50%;
    border-radius: 6px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12);
    transform: translateX(-50%);
    width: 100%;
    min-width: 250px;
    max-width: 90vw;
    padding: 1rem;
    background-color: white;
    z-index: 9999;

    a {
      color: ${primaryColor};
    }

    h6 {
      white-space: nowrap;
      margin-top: 1.5rem;
    }

    span {
      cursor: pointer;
    }
  }
`

const MapContainer = styled.div`
  height: 65vh;
  width: ${p => p.theme.col(16)};
  border-radius: 6px;
  overflow: hidden;

  @media screen and (max-width: 768px) {
    width: ${p => p.theme.col(20)};
  }
`

export default GoogleMaps



// WEBPACK FOOTER //
// ./src/components/Map/index.jsx